
var navMaxHeight;
var navOriginalHeight = $(".navbar-collapse").height();
var isNavMenuExpanded = false;

$(window).on("load", function () {
    var footerHeight = $(".footer").height();
    $("#bodyContent").css("margin-bottom", footerHeight);

    // Enable tooltips
    $("[data-toggle='tooltip']").tooltip();

    resizeContent();
    styleActiveMenu();
    setupLanguageControl();
});

$(function () {
    $(window).resize(function () {
        resizeContent();
    });

    // Resize when bootstrap divs are hidden/shown (i.e. faq's page & mobile menu)
    $("body").on("shown.bs.collapse", function () {
        resizeContent();
    });

    $("body").on("hidden.bs.collapse", function () {
        resizeContent();
    });

    var wasNavMenuVisible = $(".navbar-toggler").is(":visible");

    // Slide elements with position set to fixed or absolute with the rest of the
    // page when expanding/collapsing the bootstrap small screen nav menu
    $(window).resize(function () {
        var headerHeight = $(".navbar-collapse").height();
        if (!navMaxHeight || headerHeight > navOriginalHeight) {
            navMaxHeight = headerHeight;
        }

        if (!$(".navbar-toggler").is(":visible")) {
            if (wasNavMenuVisible) {
                // Slide the items back up again if the window was expanded with the menu open
                $(".slide-with-header.menu-down").each(function () {
                    $(this).removeClass("menu-down");
                    $(this).css("top", "-=" + navMaxHeight);
                });
            }
        } else {
            // Slide down again if the menu is expanded when resizing
            if (!wasNavMenuVisible && isNavMenuExpanded) {
                $(".slide-with-header").each(function () {
                    if (!$(this).hasClass("menu-down")) {
                        $(this).addClass("menu-down");
                        $(this).css("top", "+=" + navMaxHeight);
                    }
                });
            }
        }

        wasNavMenuVisible = $(".navbar-toggler").is(":visible");
    });

    // slide any 'absolute' or 'fixed' positioned divs when opening/closing bootstrap navbar
    $(".navbar-toggler").on("click", function () {
        slideFixedContentWithNav();
    });

    $(".nav-item.dropdown").on("shown.bs.dropdown", function () {
        slideFixedContentWithSubNav(this);
    });

    $(".nav-item.dropdown").on("hidden.bs.dropdown", function () {
        slideFixedContentWithSubNav(this);
    });
});


function slideFixedContentWithSubNav(element) {
    var nav = $(".navbar-collapse");

    // Don't do anything if the dropdown menu isn't visible
    if ($(".navbar-toggler-icon").is(":visible") && nav.hasClass("show")) {
        var navItem = $(element);
        var originalHeight = navMaxHeight;
        var totalHeight = $(".navbar-collapse").height();
        var valueToSlide = totalHeight - originalHeight;

        navMaxHeight = totalHeight;

        if (navItem.parent().hasClass("show")) {
            $(".slide-with-header").each(function () {
                // closing bootstrap nav - slide elements up
                $(this).css({
                    top: "-=" + valueToSlide,
                    WebkitTransition: "left 800ms",
                    MozTransition: "left 800ms",
                    MsTransition: "left 800ms",
                    OTransition: "left 800ms",
                    transition: "left 800ms"
                });
            });
        } else {
            $(".slide-with-header").each(function () {
                // opening bootstrap nav - slide elements down
                $(this).css({
                    top: "+=" + valueToSlide,
                    WebkitTransition: "left 800ms",
                    MozTransition: "left 800ms",
                    MsTransition: "left 800ms",
                    OTransition: "left 800ms",
                    transition: "left 800ms"
                });
            });
        }
    }
}


function slideFixedContentWithNav() {
    var nav = $(".navbar-collapse");
    var headerHeight = nav.height();
    if (!navMaxHeight || headerHeight > navOriginalHeight) {
        navMaxHeight = headerHeight;
    }

    if (nav.hasClass("show")) {
        $(".slide-with-header").each(function () {
            // closing bootstrap nav - slide elements up
            $(this).css({
                top: "-=" + navMaxHeight,
                WebkitTransition: "left 800ms, top 0.3s",
                MozTransition: "left 800ms, top 0.3s",
                MsTransition: "left 800ms, top 0.3s",
                OTransition: "left 800ms, top 0.3s",
                transition: "left 800ms, top 0.3s"
            });

            if ($(this).addClass("menu-down")) {
                $(this).removeClass("menu-down");
            }
        });

        isNavMenuExpanded = false;
    } else {
        $(".slide-with-header").each(function () {
            // opening bootstrap nav - slide elements down
            $(this).css({
                top: "+=" + navMaxHeight,
                WebkitTransition: "left 800ms, top 0.3s",
                MozTransition: "left 800ms, top 0.3s",
                MsTransition: "left 800ms, top 0.3s",
                OTransition: "left 800ms, top 0.3s",
                transition: "left 800ms, top 0.3s"
            });

            $(this).addClass("menu-down");
        });

        isNavMenuExpanded = true;
    }
}


function setupLanguageControl() {
    $(".language-selector a").on("click", function () {
        setLanguage($(this).html());
    });
}

function setLanguage(lang) {
    $.ajax({
        type: "POST",
        url: "/home/setlanguage?lang=" + lang,
        success: function (response) {
            location.reload();
        },
        error: function () {
            console.log("An error has occured while setting language.");
        }
    });
}


function styleActiveMenu() {
    var hdnActiveMenu = $("#activeMenu");
    if (hdnActiveMenu) {
        var activeMenuId = hdnActiveMenu.val();
        var activeMenu = $("#" + activeMenuId);
        if (activeMenu) {
            activeMenu.addClass("is-active");
        }
    }
}

// these functions are available globally (i.e. from HTML)
window.resizeContent = function () {
    var bodyHeight = $("body").height();
    var windowHeight = $(window).height();

    var footerHeight = $(".footer").height();
   

    if ($(".footer").hasClass("footer-fixed")) {
        if ((bodyHeight + footerHeight) < windowHeight) {
            $(".footer").removeClass("footer-fixed");
            $("#bodyContent").css("margin-bottom", "20px");
        }
    } else {
        if (bodyHeight < windowHeight) {
            $(".footer").removeClass("footer-fixed");
            $("#bodyContent").css("margin-bottom", "20px");
        } else {
            $(".footer").addClass("footer-fixed");
            $("#bodyContent").css("margin-bottom", "20px");
        }
    }
}
